/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
import Helpers from "utils/Global/Helpers";

// import { mockedUploadedFiles, mockedUploadedURLs } from "./mockData";
// import { mockActivityTabContent } from "./mockActivityTabContent";
// import { mockMessageTabContent } from "./mockMessageTabContent";

export default {
  getSession: ({ credentials, sessionId }) =>
    new Promise((success, error) => {
      Helpers.request({
        method: "get",
        url: `${window.__LENND_API_BASE_URL__}/sessions/session/${sessionId}`,
        credentials,
        success,
        error
      });
    }),
  addSession: ({ credentials, data }) =>
    new Promise((success, error) => {
      Helpers.request({
        method: "post",
        url: `${window.__LENND_API_BASE_URL__}/sessions/session`,
        credentials,
        data,
        success,
        error
      });
    }),
  updateSession: ({ credentials, data }) =>
    new Promise((success, error) => {
      Helpers.request({
        method: "put",
        url: `${window.__LENND_API_BASE_URL__}/sessions/session/${data.sessionId}`,
        credentials,
        data,
        success,
        error
      });
    }),
  unlinkSubsession: ({ credentials, subsessionId }) =>
    new Promise((success, error) => {
      Helpers.request({
        method: "put",
        url: `${window.__LENND_API_BASE_URL__}/sessions/sub-session/${subsessionId}/unlink`,
        credentials,
        success,
        error
      });
    }),
  deleteSubsession: ({ credentials, subsessionId }) =>
    new Promise((success, error) => {
      Helpers.request({
        method: "delete",
        url: `${window.__LENND_API_BASE_URL__}/sessions/sub-session/${subsessionId}`,
        credentials,
        success,
        error
      });
    }),
  updateSubsession: ({ credentials, data }) =>
    new Promise((success, error) => {
      Helpers.request({
        method: "put",
        url: `${window.__LENND_API_BASE_URL__}/sessions/session/${data.sessionId}/sub-sessions`,
        credentials,
        data,
        success,
        error
      });
    }),

  // Messages
  getMessages: ({ credentials, data }) =>
    new Promise((success, error) => {
      // setTimeout(() => success({ payload: mockMessageTabContent }), 2000);
      // Helpers.request({
      //   method: "get",
      //   url: `${window.__LENND_API_BASE_URL__}/sessions/session/messages/${data.sessionId}`,
      //   credentials,
      //   data,
      //   success,
      //   error
      // });
    }),
  // To be removed when BE is working
  // postMessages: ({ credentials, data, messages }) =>
  //   new Promise((success, error) => {
  //     success([...messages, { ...messages[0], comment: data }]);
  //     Helpers.request({
  //       method: "post",
  //       url: `${window.__LENND_API_BASE_URL__}/sessions/session/${data.sessionId}`,
  //       credentials,
  //       data,
  //       success,
  //       error
  //     });
  //   }),
  // Activity
  getActivity: ({ credentials, data }) =>
    new Promise((success, error) => {
      //     console.log("getActivity", { data, mockActivityTabContent });
      //     success({ payload: mockActivityTabContent });
      Helpers.request({
        //   method: "get",
        //   url: `${window.__LENND_API_BASE_URL__}/sessions/session/${data.sessionId}`,
        //   credentials,
        //   data,
        //   success,
        //   error
      });
    }),
  // Content
  postFiles: ({ credentials, sessionId, eventId, data }) =>
    new Promise((success, error) => {
      Helpers.request({
        method: "post",
        url: `${window.__LENND_API_BASE_URL__}/portal/event/${eventId}/session-content/${sessionId}/content/bulk`,
        credentials,
        data,
        success,
        error
      });
    }),
  // postUrls: ({ credentials, data }) =>
  //   new Promise((success, error) => {
  //     console.log("postLinks", { data });
  //     success({ payload: [] });
  //     Helpers.request({
  //       method: "post",
  //       url: `${window.__LENND_API_BASE_URL__}/sessions/session/${data.sessionId}`,
  //       credentials,
  //       data,
  //       success,
  //       error
  //     });
  //   }),
  getContent: ({ credentials, sessionId, eventId }) =>
    new Promise((success, error) => {
      // setTimeout(() => success({ payload: mockedUploadedFiles }), 2000);
      // Helpers.request({
      //   method: "get",
      //   url: `${window.__LENND_API_BASE_URL__}/portal/event/:eventUUID/session-content/:sessionId/content`,
      //   credentials,
      //   success,
      //   error
      // });
    }),
  getUrls: ({ credentials, data }) =>
    new Promise((success, error) => {
      // setTimeout(() => success({ payload: mockedUploadedURLs }), 2000);
      // Helpers.request({
      //   method: "get",
      //   url: `${window.__LENND_API_BASE_URL__}/sessions/session/${data.sessionId}`,
      //   credentials,
      //   data,
      //   success,
      //   error
      // });
    }),
  postCommentVersion: ({ credentials, eventId, sessionId, contentId, data }) =>
    new Promise((success, error) => {
      const { sessionId } = data;
      Helpers.request({
        method: "post",
        url: `${window.__LENND_API_BASE_URL__}/portal/event/${eventId}/session-content/${sessionId}/content/${contentId}/comments`,
        credentials,
        data,
        success,
        error
      });
    }),
  // Actions
  changeType: ({ credentials, eventId, sessionId, contentId, data }) =>
    new Promise((success, error) => {
      const { sessionId } = data;
      Helpers.request({
        method: "put",
        url: `${window.__LENND_API_BASE_URL__}/portal/event/${eventId}/session-content/${sessionId}/content/${contentId}`,
        credentials,
        data,
        success,
        error
      });
    }),
  deleteVersion: ({ credentials, eventId, sessionId, contentId, data }) =>
    new Promise((success, error) => {
      const { sessionId } = data;
      Helpers.request({
        method: "delete",
        url: `${window.__LENND_API_BASE_URL__}/portal/event/${eventId}/session-content/${sessionId}/content/${contentId}`,
        credentials,
        data,
        success,
        error
      });
    }),
  getSessions: ({
    credentials,
    sessionId,
    page = 1,
    pageSize = 10,
    search = ""
  }) =>
    new Promise((success, error) => {
      Helpers.request({
        method: "get",
        url: `${window.__LENND_API_BASE_URL__}/sessions/session/${sessionId}/linkable-sessions?page=${page}&pageSize=${pageSize}&search=${search}`,
        credentials,
        success,
        error
      });
    }),
  linkSessionAsSubsession: ({ credentials, sessionId, subSessionIds }) =>
    new Promise((success, error) => {
      Helpers.request({
        method: "put",
        url: `${window.__LENND_API_BASE_URL__}/sessions/session/${sessionId}/sub-sessions`,
        credentials,
        data: { subSessionIds },
        success,
        error
      });
    })
};
